import { resultState } from '../../utils/format.js';
import { styles } from '../../styles/styles.js';

// A box we have no result for must not look like a box we have a losing result
// for. The old `result ? green : transparent` sent `undefined` down the false
// branch, so a team with no history rendered as ten losses — and in h2h mode,
// where the false branch is red, as ten confident away wins.
const boxColor = (result, mode) => {
  const state = resultState(result);
  if (state === 'unknown') return styles.unknownBox;
  if (mode === 'h2h') {
    return { backgroundColor: state === 'hit' ? '#40E0D0' : 'red' };
  }
  return { backgroundColor: state === 'hit' ? 'green' : 'transparent' };
};

export const LastTen = ({ results, title, mode = 'standard' }) => {
  // Callers build this with Array(10).fill().map(...) off a blob that may be
  // absent entirely, in which case they pass undefined rather than an array.
  const boxes = Array.isArray(results) ? results : [];

  return (
    <div style={{
      border: '1px solid white',
      padding: '1vh 1vw',
      borderRadius: '4px',
      width: '100%',
    }}>
      <div style={{
        display: 'flex',
        gap: 'calc(0.5vw + 2px)', // Added some responsive gap
        justifyContent: 'center',
        margin: '2vh 0',
        width: '100%'
      }}>
        {boxes.map((result, index) => (
          <div
            key={index}
            style={{
              width: 'clamp(20px, calc(15px + (4) * ((100vw - 300px) / (1200 - 320))), 35px)',
              height: 'clamp(20px, calc(15px + (4) * ((100vw - 300px) / (1200 - 320))), 35px)',
              border: '1px solid white',
              ...boxColor(result, mode),
            }}
          />
        ))}
      </div>
      
      <div style={{
        display: 'flex',
        gap: 'calc(0.5vw + 2px)',
        justifyContent: 'center',
        marginBottom: '1vh'
      }}>
        {boxes.map((_, index) => (
          <div
            key={index}
            style={{
              width: 'clamp(20px, calc(15px + (4) * ((100vw - 300px) / (1200 - 320))), 35px)',
              textAlign: 'center',
              fontSize: 'clamp(10px, calc(7px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',
              fontFamily: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace"
            }}
          >
            {boxes.length - index}
          </div>
        ))}
      </div>

      <div style={{
        textAlign: 'center',
        fontSize: 'clamp(10px, calc(7px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)',
        marginBottom: '1vh',
        fontFamily: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace"
      }}>
        {title}
      </div>
    </div>
  );
};